<template>
    <el-container>
        <div class="sanmuui-body-container">
            <div class="sanmuui-body-left" v-show="displayHTreeVisible">
              <div class="tree-divBox">
                  <el-tree 
                      :data="holdTreeData" 
                      :props="defaultProps" 
                      default-expand-all 
                      ref="getTreeInstance" 
                  @node-click="handleNodeClick"></el-tree>
              </div>
            </div>
            <div class="sanmuui-body-right">
                <el-row :gutter="10" class="queryfm-head">
                    <el-form ref="formImportSims" :model="formImportSims" :inline="true" size="small" label-width="100px">
                        <el-col :span="24">
                        <el-form-item label="导入到组织">
                            <el-input v-model="formImportSims.hold_name" :disabled="true" class="fm-holdtree-name"></el-input>
                            <label class="tip-holdselect-lbl">请选择左边的组织树节点</label>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                        <el-form-item label="卡源">
                            <select v-model="formImportSims.source_id" @change="changeSourceSel" class="fm-select-control">
                                <option v-for="item in source_options" :value="item.value">{{item.label}}</option>
                            </select>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                        <el-form-item label="运营商" prop="card_type">
                            <select v-model="formImportSims.operator_type" @change="changeOperatorTypeSel" class="fm-select-control">
                                <option v-for="item in operator_type_options" :value="item.value">{{item.label}}</option>
                            </select>
                        </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="套餐">
                                <select v-model="formImportSims.package_id" class="fm-select-control">
                                    <option v-for="item in package_options" :value="item.value">{{item.label}}</option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="卡片类型" prop="card_type">
                                <select v-model="formImportSims.card_type" class="fm-select-control">
                                    <option v-for="item in card_type_options" :value="item.value">{{item.label}}</option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="导入方式">
                            <el-radio-group v-model="formImportSims.up_control_type" @input="changeImportControlType">
                                <el-radio label="1">根据ICCID卡号</el-radio>
                                <el-radio label="2">上传文件</el-radio>
                            </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="displayUpICCIDControl">
                            <el-form-item label="ICCID卡号">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 10, maxRows: 30}"
                                placeholder="输入ICCID卡号，支持多个，用逗号','或换行符隔开"
                                v-model="formImportSims.iccids"
                                style="width: 400px;">
                            </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="displayUpExcelControl">
                            <el-form-item label="选择文件">
                            <el-upload
                                class="upload-demo"
                                action="/proxyserver/api/UploadFiles/action"
                                :limit="1"
                                :auto-upload="true"
                                :on-success="onUploadSuccess"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件，且不超过50M</div>
                                <div slot="tip" class="el-upload__tip">
                                <el-link href="https://api.sanmuiot.com/api/Sim/temp_device" type="warning" target="_blank">点击下载模板</el-link>
                                </div>
                            </el-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18" :offset="6">
                            <el-form-item>
                                <el-button size="small" @click="resetForm">重置</el-button>
                                <el-button type="success" @click="submitImport" size="small">{{submitBtnText}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                
                <el-row>
                    <el-col :span="18" :offset="6">
                        <el-descriptions class="margin-top" :title="importResultTip" :column="3" border>
                            <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-success"></i>
                                成功数量
                            </template>
                            {{successTotal}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                            <template slot="label">
                                <i class="el-icon-error"></i>
                                失败ICCID
                            </template>
                            {{failICCIDList}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'import_sims',
  data() {
    return {
        displayHTreeVisible: true,
        selectHoldId: 0,
        selectedHoldName: "",
        holdTreeData: [],
        defaultProps: {
            children: 'children',
            label: 'label'
        },
        displayUpICCIDControl: true,
        displayUpExcelControl: false,
        operator_type_options: [],
        card_type_options: [],
        status_options: [],
        package_options: [],
        source_options: [],
        formImportSims: {
            hold_id: 0,
            hold_name: "",
            operator_type: 0,
            operator_type_text: "请选择",
            card_type: 0,
            card_type_text: "请选择",
            package_id: null,
            package_text: "请选择",
            source_id: null,
            source_text: "请选择",
            iccids: "",
            up_control_type: "1",
            upload_file_path: "",
        },
        successTotal: 0,
        failICCIDList: "",
        submitBtnText: "提交",
        importResultTip: "导入结果",
    }
  },
  methods: {
    handleNodeClick: function(data) {
        this.selectHoldId = data.id;
        this.selectedHoldName = data.label;
        this.formImportSims.hold_id = data.id;
        this.formImportSims.hold_name = data.label;
    },
    changeImportControlType: function(val) {
      if(val == '1') {
        this.displayUpICCIDControl = true;
        this.displayUpExcelControl = false;
      } else if (val == '2') {
        this.displayUpICCIDControl = false;
        this.displayUpExcelControl = true;
      }
    },
    loadSourceOptions: function() {
        this.source_options = [];
        Api.SourceOptions({}).then(res => {
            if(res && res.data) {
                res.data.forEach(element => {
                    this.source_options.push({
                        value: element.source_id,
                        label: element.source_name
                    })
                });
                this.formImportSims.source_id = res.data[0].source_id;
            }
        });
    },
    changeSourceSel: function() {
        this.loadPkgOptionItems()
    },
    changeOperatorTypeSel: function() {
        this.loadPkgOptionItems()
    },
    loadDictionOptions: function() {
      var multipleIds = "1,2,3";
      Api.GetDetailMultipleItems({ dict_ids: multipleIds }).then(res => {
        if(res && res.code === 200) {
          if(res.data) {
            res.data.forEach(element => {
              if(element.dict_id === 1) {
                this.operator_type_options = element.options;
              } else if(element.dict_id === 2) {
                this.card_type_options = element.options;
              } else if(element.dict_id === 3) {
                // 卡状态
                // this.status_options = element.options;
              }
            });
            this.formImportSims.operator_type = this.operator_type_options[0].value;
            this.formImportSims.card_type = this.card_type_options[0].value;
          }
        }
      });
    },
    loadPkgOptionItems: function() {
        var argdata = {
            source_id: this.formImportSims.source_id,
            operator_type: this.formImportSims.operator_type
        }
        this.package_options = []
        Api.QueryPkgOptionItems(argdata).then(res => {
            if(res && res.code === 200) {
                res.data.forEach(element => {
                    this.package_options.push({
                        value: element.package_id,
                        label: element.package_name
                    })
                })
            }
        })
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;

        if(res.code !== 200)
          return;

        this.holdTreeData = res.data;

        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
        this.formImportSims.hold_id = this.selectHoldId;
        this.formImportSims.hold_name = this.selectedHoldName;
      });
    },
    onUploadSuccess: function(response, file, fileList) {
      if(response.errCode === 0) {
        this.formImportSims.upload_file_path = response.result.imagePath;
        console.log(response.result.imagePath);
      } else {
        this.formImportSims.upload_file_path = "";
      }
    },
    splitByCommaOrNewline: function(str) {
      // 使用正则表达式匹配逗号或换行符（包括Windows和Unix风格的换行符）
      return str.split(/[,|\r\n|\n|\r]+/)
        // 过滤掉空字符串
        .filter(item => item.trim() !== '');
    },
    submitImport: function() {
        this.submitBtnText = "导入中..";
        if(this.formImportSims.up_control_type === '1') {
            // 按ICCID号导入方式
            const list = this.splitByCommaOrNewline(this.formImportSims.iccids);

            if(list.length === 0) {
                this.$message.error('请输入ICCID号');
                return;
            }

            var cardArr = [];
            list.forEach(item => {
                cardArr.push({
                    iccid: item,
                    sim: "",
                });
            });

            var argdata = {
                hold_id: this.formImportSims.hold_id,
                operator_type: this.formImportSims.operator_type,
                card_type: this.formImportSims.card_type,
                source_id: this.formImportSims.source_id,
                package_id: this.formImportSims.package_id,
                cards: cardArr
            };

            Api.ImportSimsByIccids(argdata).then(res => {
                this.submitBtnText = "提交";
                this.importResultTip = "导入完成！";
                if(!res) {
                    this.$message.error('导入失败！');
                    this.successTotal = 0;
                    this.failICCIDList = list.join(",");
                    return;
                }
                if(res.code === 200 && res.data) {
                    this.successTotal = res.data.success;
                    this.failICCIDList = res.data.failed_iccids.join(",");
                } else {
                    this.$message.error('导入失败！');
                    this.successTotal = 0;
                    this.failICCIDList = list.join(",");
                }
            });
        } else if(this.formImportSims.up_control_type === '2') {
            // 上传文件
            if(!this.formImportSims.upload_file_path) {
                this.$message.error('请上传Excel文件！');
                return;
            }

            var argdata = {
                hold_id: this.formImportSims.hold_id,
                operator_type: this.formImportSims.operator_type,
                card_type: this.formImportSims.card_type,
                source_id: this.formImportSims.source_id,
                package_id: this.formImportSims.package_id,
                file_name: this.formImportSims.upload_file_path
            };
            Api.ImportSimsByExcel(argdata).then(res => {
                this.submitBtnText = "提交";
                this.importResultTip = "导入完成！";
                if(!res) {
                    this.$message.error('导入失败！');
                    this.successTotal = 0;
                    this.failICCIDList = list.join(",");
                    return;
                }
                if(res.code === 200 && res.data) {
                    this.successTotal = res.data.success;
                    this.failICCIDList = res.data.failed_iccids.join(",");
                } else {
                    this.$message.error('导入失败！');
                    this.successTotal = 0;
                    this.failICCIDList = list.join(",");
                }
            });
        } else {
            this.$message.error('请选择有效导入方式');
            return;
        }
    },
    resetForm: function() {
        this.successTotal = 0;
        this.failICCIDList = "";
        this.formImportSims.upload_file_path = "";
        this.formImportSims.iccids = "";
    }
  },
  mounted() {
    var h = document.body.clientHeight - 100;
    this.$nextTick(() => {
        const tree = this.$refs.getTreeInstance;
        if(tree) {
            tree.$el.style.height = h + 'px';
        }

        this.loadHoldTree();
        this.loadSourceOptions();
        this.loadDictionOptions();
    });
  }
}
</script>

<style scoped>
.queryfm-head {
    padding-top: 10px;
    padding-bottom: 10px;
}
.fm-holdtree-name {
    width: 300px;
}
.tip-holdselect-lbl {
    color: #ff0000;
    margin-left: 5px;
}
</style>